import { render, staticRenderFns } from "./AddShift.vue?vue&type=template&id=5f994186&scoped=true"
import script from "./AddShift.vue?vue&type=script&lang=ts"
export * from "./AddShift.vue?vue&type=script&lang=ts"
import style0 from "./AddShift.vue?vue&type=style&index=0&id=5f994186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f994186",
  null
  
)

export default component.exports